import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=19b3c73d&scoped=true&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HistoryOrder.vue?vue&type=style&index=1&id=19b3c73d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b3c73d",
  null
  
)

export default component.exports